import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Loader2 } from 'lucide-react'
import { Card, CardContent } from './card'

interface EnhancementGoalsProps {
  questions: string[]
  userResponse: string
  onUserResponseChange: (value: string) => void
  onSubmit: () => void
  isLoading: boolean
}

export const EnhancementGoals = ({
  questions,
  userResponse,
  onUserResponseChange,
  onSubmit,
  isLoading,
}: EnhancementGoalsProps) => {
  return (
    <Card>
      <CardContent>
        <div className="mb-4">
          <header className="flex items-center justify-between mb-2 font-semibold text-gray-900 dark:text-gray-100">
            Enhancement Goals
          </header>
          <ul className="space-y-2">
            {questions.map((question, index) => (
              <li key={index}>{question}</li>
            ))}
          </ul>
        </div>
        {/* Textarea for user response */}
        <div className="mb-4 flex gap-2 items-end">
          <Textarea
            placeholder="Enter your Goals"
            value={userResponse}
            onChange={e => onUserResponseChange(e.target.value)}
            disabled={isLoading}
          />

          {/* Button to submit user response */}
          <Button
            className="h-12 px-4 cursor-pointer"
            onClick={onSubmit}
            disabled={isLoading}
          >
            Submit {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
